import { render } from "./Test.vue?vue&type=template&id=416bf927&scoped=true"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import "./Test.vue?vue&type=style&index=0&id=416bf927&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-416bf927"

export default script